"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var OptGroup = function OptGroup(_ref) {
  var children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/_react.default.createElement("optgroup", otherProps, children);
};

var Option = function Option(_ref2) {
  var label = _ref2.label,
      otherProps = _objectWithoutProperties(_ref2, ["label"]);

  return /*#__PURE__*/_react.default.createElement("option", otherProps, label);
};

var ClaySelect = function ClaySelect(_ref3) {
  var children = _ref3.children,
      className = _ref3.className,
      otherProps = _objectWithoutProperties(_ref3, ["children", "className"]);

  return /*#__PURE__*/_react.default.createElement("select", _extends({}, otherProps, {
    className: (0, _classnames.default)('form-control', className)
  }), children);
};

ClaySelect.OptGroup = OptGroup;
ClaySelect.Option = Option;
var _default = ClaySelect;
exports.default = _default;